import React from 'react';
import PropTypes from 'prop-types';
import { FaCheckCircle, FaTimesCircle, FaTimes } from 'react-icons/fa';

const Alert = ({ message, type, onClose }) => {
  if (!message) {
    return null;
  }

  // Define styles and icons based on the alert type
  const alertConfig = {
    success: {
      bgColor: 'bg-green-100',
      borderColor: 'border-green-400',
      textColor: 'text-green-800',
      icon: <FaCheckCircle className="h-5 w-5" />,
    },
    error: {
      bgColor: 'bg-red-100',
      borderColor: 'border-red-400',
      textColor: 'text-red-800',
      icon: <FaTimesCircle className="h-5 w-5" />,
    },
  };

  const config = alertConfig[type];

  return (
    <div
      className={`fixed top-5 right-5 z-[99] flex items-center justify-between p-4 mb-4 rounded-lg border ${config.bgColor} ${config.borderColor} ${config.textColor}`}
      role="alert"
    >
      <div className="flex items-center">
        {/* Icon */}
        <span className="mr-3">{config.icon}</span>
        {/* Message */}
        <span className="font-medium">{message}</span>
      </div>

      {/* Close Button */}
      {onClose && (
        <button
          onClick={onClose}
          className={`ml-4 -mr-1 -my-1 p-1.5 rounded-md ${config.textColor} hover:bg-opacity-20 hover:bg-current transition-colors`}
          aria-label="Close"
        >
          <FaTimes className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};

Alert.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error']).isRequired,
  onClose: PropTypes.func,
};

export default Alert;